import { render, staticRenderFns } from "./HeartRateAnalyze.vue?vue&type=template&id=4b70df86&scoped=true&"
import script from "./HeartRateAnalyze.vue?vue&type=script&lang=js&"
export * from "./HeartRateAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./HeartRateAnalyze.vue?vue&type=style&index=0&id=4b70df86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70df86",
  null
  
)

export default component.exports